import {DialogWrapper} from './components/DialogWrapper'
import styles from './Dialog.module.scss'

export const Dialog: React.FC = () => {
  return (
    <div className={styles.dialog}>
      <DialogWrapper />
    </div>
  )
}
